import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const BoardDetail = () => {
  const { id } = useParams(); // URL에서 게시글 ID를 가져옴
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [comments, setComments] = useState([]); // 댓글 상태
  const [newComment, setNewComment] = useState(""); // 새 댓글 입력 상태
  const [likes, setLikes] = useState(0); // 좋아요 수 상태
  const [unlikes, setunlikes] = useState(0);

  // 게시글 데이터 불러오기
  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://jsonplaceholder.typicode.com/posts/${id}`
        );
        setPost(response.data);
        setLoading(false);
      } catch (err) {
        setError("게시글을 불러오는 데 실패했습니다.");
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  // 댓글 추가 함수
  const addComment = () => {
    if (newComment.trim()) {
      setComments([...comments, newComment]);
      setNewComment(""); // 입력란 초기화
    }
  };

  // 좋아요 증가 함수
  const handleLike = () => {
    setLikes(likes + 1);
  };

  // 좋아요 증가 함수
  const handunleLike = () => {
    setunlikes(unlikes + 1);
  };

  if (loading) return <p>로딩 중...</p>;
  if (error) return <p>{error}</p>;
  if (!post) return <p>게시글이 존재하지 않습니다.</p>;

  return (
    <div className="board-detail">
      <div className="board-title">
        <h2>{post.title}</h2>
        <p>{post.body}</p>
        <p>작성자: 사용자{post.userId}</p>
        <p>게시글 ID: {post.id}</p>
      </div>

      {/* 좋아요 버튼 및 카운트 */}
      <div className="likes-section">
        <button onClick={handleLike}>👍 좋아요</button>
        <p>좋아요: {likes}</p>
      </div>

      {/* 싫어요 버튼 및 카운트 */}
      <div className="unlikes-section">
        <button onClick={handunleLike}>👍 싫어요</button>
        <p>싫어요: {unlikes}</p>
      </div>

      {/* 댓글 입력 및 목록 */}
      <div className="comments-section">
        <h3>댓글</h3>
        <input
          type="text"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="댓글을 입력하세요."
        />
        <button onClick={addComment}>입력</button>

        <div className="comments-list">
          {comments.length > 0 ? (
            comments.map((comment, index) => <p key={index}>{comment}</p>)
          ) : (
            <p>댓글이 없습니다.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BoardDetail;
